/**
 * Styles hidden from studio catalog & recommendations (near-duplicates / redundant variants).
 * Keep in sync with backend/nyafaz-ep/hair_styling/hidden_prompt_style_ids.py
 */
export const HIDDEN_PROMPT_STYLE_IDS = new Set([
  // women — short / bob variants
  'women_textured_pixie',
  'women_long_pixie',
  'women_blunt_bob',
  'women_inverted_bob',
  'women_a_line_bob',
  'women_italian_bob',
  'women_shaggy_bob',
  // women — medium layers (overlap)
  'women_textured_lob',
  'women_feathered_layers',
  'women_face_framing_layers',
  'women_u_cut',
  'women_v_cut',
  'women_step_cut',
  'women_curtain_layer_cut',
  // women — long layers (overlap)
  'women_long_u_cut',
  'women_long_v_cut',
  'women_butterfly_layers',
  'women_face_framing_long_layers',
  'women_korean_long_layers',
  'women_soft_long_layers',
  // women — curls / waves
  'women_wolf_cut_curls',
  'women_defined_long_curls',
  'women_soft_waves',
  'women_hollywood_waves',
  'women_loose_curls',
  // women — ponytails
  'women_sleek_ponytail',
  'women_textured_ponytail',
  'women_bubble_ponytail',
  'women_side_ponytail',
  'women_high_voluminous_ponytail',
  // women — updos
  'women_sleek_low_bun',
  'women_high_bun',
  'women_top_knot',
  'women_braided_bun',
  'women_low_textured_updo',
  // women — braids
  'women_classic_three_strand_braid',
  'women_waterfall_braid',
  'women_side_braid',
  'women_rope_braid',
  'women_milkmaid_braid',
  'women_half_up_braid',
  // women — bridal overlap
  'women_long_temple_braid',
  'women_braided_bridal_updo',
  'women_half_up_bridal_waves',
  'women_low_bridal_chignon',
  'women_classic_bridal_updo',
  // women — trendy overlap
  'women_octopus_cut',
  'women_jellyfish_cut',
  'women_italian_layers',
  'women_korean_layered_cut',
  'women_soft_shag',
  'women_modern_mullet',

  // men — short / military overlap
  'men_induction_cut',
  'men_high_and_tight',
  'men_military_cut',
  'men_short_crop',
  'men_short_spiky_hair',
  'men_short_textured_hair',
  'men_short_side_part',
  'men_short_slick_back',
  'men_short_quiff',
  // men — fades (catalog keeps low_fade + drop_fade only)
  'men_mid_fade',
  'men_high_fade',
  'men_skin_fade',
  'men_burst_fade',
  'men_fade_with_textured_top',
  'men_curly_fade',
  'men_bald_fade',
  'men_taper_fade',
  'men_low_taper_fade',
  'men_mid_taper_fade',
  'men_high_taper_fade',
  'men_temple_fade',
  'men_shadow_fade',
  'men_skin_fade_with_crop',
  // men — medium overlap
  'men_modern_side_part',
  'men_textured_side_part',
  'men_medium_quiff',
  'men_textured_quiff',
  'men_modern_pompadour',
  'men_textured_slick_back',
  'men_brushed_back',
  'men_middle_part',
  'men_messy_flow',
  'men_layered_medium_cut',
  // men — long overlap
  'men_long_straight_hair',
  'men_long_curly_hair',
  'men_half_up_man_bun',
  'men_low_man_bun',
  'men_top_knot',
  'men_long_slick_back',
  'men_shoulder_length_flow',
  'men_long_shag',
  // men — curly / wavy overlap
  'men_curly_crop',
  'men_curly_taper',
  'men_short_curly_top',
  'men_medium_curly_layers',
  'men_long_curly_layers',
  'men_wavy_crop',
  'men_wavy_quiff',
  'men_wavy_side_part',
  'men_curly_shag',
  'men_textured_waves',
  // men — trendy overlap
  'men_modern_mullet',
  'men_burst_fade_mullet',
  'men_textured_mullet',
  'men_korean_curtain_cut',
  'men_korean_comma_hair',
  'men_k_pop_layered_cut',
  'men_textured_fringe',
  'men_messy_fringe',
  'men_french_crop_fade',
  'men_disconnected_undercut',
  // men — professional overlap
  'men_classic_pompadour',
  'men_gentleman_s_side_part',
  'men_comb_over',
  'men_hard_part',
  'men_low_taper_side_part',
  // men — indian overlap
  'men_side_swept_indian_cut',
  'men_messy_indian_quiff',
  'men_long_layered_indian_hair',
  'men_indian_slick_back',
  'men_textured_fade',
  'men_low_fade_beard',
  'men_mid_fade_quiff',
  'men_taper_side_part',
]);

export function isPromptStyleHidden(styleId) {
  const id = String(styleId || '').trim();
  return id && HIDDEN_PROMPT_STYLE_IDS.has(id);
}
